/**
 * Partnerbereich: "Mein Profil" - Name, E-Mail und Passwort aendern
 */

import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { partnerAPI } from '../../services/api';
import './Partner.css';

const PartnerProfil = () => {
  const { user, aktualisiereUser } = useAuth();
  const [name, setName] = useState(user?.name || '');
  const [email, setEmail] = useState(user?.email || '');
  const [aktuell, setAktuell] = useState('');
  const [neu, setNeu] = useState('');
  const [neu2, setNeu2] = useState('');
  const [sendet, setSendet] = useState(false);
  const [meldung, setMeldung] = useState(null); // { typ, text }

  const speichern = async (e) => {
    e.preventDefault();
    setMeldung(null);
    if (neu && neu !== neu2) {
      setMeldung({ typ: 'fehler', text: 'Die neuen Passwörter stimmen nicht überein.' });
      return;
    }
    if (neu && neu.length < 6) {
      setMeldung({ typ: 'fehler', text: 'Das neue Passwort muss mindestens 6 Zeichen lang sein.' });
      return;
    }
    setSendet(true);
    try {
      const res = await partnerAPI.updateProfil({
        name,
        email,
        ...(neu ? { aktuellesPasswort: aktuell, neuesPasswort: neu } : {})
      });
      aktualisiereUser(res.data.user, res.data.token);
      setAktuell(''); setNeu(''); setNeu2('');
      setMeldung({ typ: 'erfolg', text: 'Gespeichert.' });
    } catch (err) {
      setMeldung({ typ: 'fehler', text: err.response?.data?.error || 'Speichern hat nicht geklappt.' });
    }
    setSendet(false);
  };

  return (
    <div className="partner-page">
      <h1 className="pt-titel">Mein Profil</h1>
      <div className="pt-card pt-schmal">
        <form onSubmit={speichern} className="pt-form">
          <label>
            Name
            <input value={name} onChange={e => setName(e.target.value)} required />
          </label>
          <label>
            E-Mail (für Login und Bestätigungen)
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </label>

          <h2 className="pt-abschnitt">Passwort ändern</h2>
          <p className="pt-muted">Nur ausfüllen, wenn du dein Passwort ändern möchtest.</p>
          <label>
            Aktuelles Passwort
            <input type="password" value={aktuell} onChange={e => setAktuell(e.target.value)} autoComplete="current-password" />
          </label>
          <div className="pt-feldreihe">
            <label>
              Neues Passwort
              <input type="password" value={neu} onChange={e => setNeu(e.target.value)} autoComplete="new-password" />
            </label>
            <label>
              Neues Passwort wiederholen
              <input type="password" value={neu2} onChange={e => setNeu2(e.target.value)} autoComplete="new-password" />
            </label>
          </div>

          {meldung && <div className={meldung.typ === 'fehler' ? 'pt-fehler' : 'pt-erfolg'}>{meldung.text}</div>}

          <div className="pt-aktionen">
            <button type="submit" className="pt-btn pt-btn-primaer" disabled={sendet}>
              {sendet ? 'Speichert…' : 'Speichern'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PartnerProfil;
